import { render, staticRenderFns } from "./RegiaoForm.vue?vue&type=template&id=6a4478ad&lang=html&"
import script from "./RegiaoForm.vue?vue&type=script&lang=js&"
export * from "./RegiaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/regiao/RegiaoForm.vue
// module id = 1453
// module chunks = 28